import { render, staticRenderFns } from "./ChangeGarnitureMass.vue?vue&type=template&id=0dfda5ec&"
import script from "./ChangeGarnitureMass.vue?vue&type=script&lang=js&"
export * from "./ChangeGarnitureMass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports